import { EsgEligibilityIcon } from 'components/esg-eligibility/esg-eligibility-icon';
import { UnderlyingTooltipIcon } from 'components/shared/UnderlyingInfo/underlying-tooltip-icon';
import { WithUnderlyingInfoTooltip } from 'components/shared/UnderlyingInfo/WithUnderlyingInfoTooltip';
import { UnderlyingTag } from 'components/underlying-tag';
import { asEquityUnderlying, Underlying } from 'models/underlying';
import { useCallback } from 'react';

import { Cutoffs } from './cutoff';

function getCodeByAssetType(underlying: Underlying) {
  switch (underlying.asset) {
    case 'Equity':
    case 'Commodity':
    case 'Rate':
      return underlying.bloombergTickerCode;
    case 'CreditRate':
      return underlying.curveName;
  }
}

function mapUnderlyingToRowData(underlying: Underlying) {
  return {
    code: getCodeByAssetType(underlying),
    name: underlying.name,
  };
}

type Props = {
  underlying: Underlying;
  onChangeUnderlyings: (value: Underlying[]) => void;
  onClear: () => void;
  showEsgEligibilityFlag: boolean;
};
export function Row({ underlying, onChangeUnderlyings, onClear, showEsgEligibilityFlag }: Props) {
  const rowData = mapUnderlyingToRowData(underlying);
  const onSelectCutoff = useCallback(
    (cutoff: string) => {
      const modifiedUnderlying = {
        ...underlying,
        cutOff: cutoff,
      };
      const value = [underlying].map(u => (u.id === underlying.id ? modifiedUnderlying : u));
      onChangeUnderlyings(value);
    },
    [underlying, onChangeUnderlyings],
  );
  const equityUnderlying = asEquityUnderlying(underlying);
  return (
    <li className="list-group-item d-flex gap-1 border-bottom border-opacity-40 p-0 py-1 align-items-center">
      <div className="underlyings-card-result-badge d-flex align-items-center justify-content-start">
        <UnderlyingTag label={rowData.code ?? rowData.name} value={underlying} isReadOnly size="lg" />
      </div>
      <div className="underlyings-card-eligibility-flag d-flex align-items-center justify-content-center">
        {showEsgEligibilityFlag && (
          <EsgEligibilityIcon
            isEligible={equityUnderlying?.esgEligibility}
            isEligibleWithCondition={equityUnderlying?.esgExtendedEligibility}
            size="sm"
          />
        )}
      </div>
      <div className="underlyings-card-name d-flex align-items-center flex-grow-1">
        <span className="ms-2 text-secondary w-100">{rowData.code && rowData.name}</span>
      </div>
      <div className="underlyings-card-cutoffs d-flex align-items-center justify-content-center">
        {underlying.asset === 'Forex' && (
          <Cutoffs
            cutoffs={underlying.cutOffs ?? null}
            selected={underlying.cutOff ?? underlying.defaultCutOff ?? null}
            onSelect={onSelectCutoff}
          />
        )}
      </div>
      <div className="underlyings-card-info d-flex align-items-center justify-content-center">
        <WithUnderlyingInfoTooltip underlying={underlying}>
          <UnderlyingTooltipIcon underlying={underlying} />
        </WithUnderlyingInfoTooltip>
      </div>
      <div className="underlyings-card-clear d-flex align-items-center justify-content-center">
        <button className="btn btn-flat-secondary btn-icon" onClick={onClear}>
          <i className="icon">cancel</i>
        </button>
      </div>
    </li>
  );
}
